module.exports = __webpack_public_path__ + "static/img/dgf4.98dbbd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/dgf4.jpg
// module id = e33U
// module chunks = 0